// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"af4d24b43642671dc5ac","966":"15d3cd80be6c5f7a0ae1"}[chunkId] + ".js";
};